import {Callout} from "@radix-ui/themes";
import styles from "../styles/SlateEditor.module.scss";
import FontAwesome from "../../utilities/FontAwesome";

export function ScriptPlaceholder(props) {
    return <div contentEditable={false} className={styles.scriptPlaceholder}>
        <Callout.Root variant={"outline"}>
            <Callout.Icon>
                <FontAwesome prefix={"fas"} name={"fa-code"} />
            </Callout.Icon>
            <Callout.Text weight={"bold"} contentEditable={false}>
                {`<script> Embedded Script - Edit in Raw HTML </script>`}
            </Callout.Text>
        </Callout.Root>
    </div>
}